export default __webpack_public_path__ + "static/media/business-266-2a.b85e75cc.jpg";